// LIST
export const FETCH_BODYMAP = "app/BODYMAP/FETCH_BODYMAP";
export const FETCH_BODYMAP_SUCCESS = "app/BODYMAP/FETCH_BODYMAP_SUCCESS";
export const FETCH_BODYMAP_FAILURE = "app/BODYMAP/FETCH_BODYMAP_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/BODYMAP/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/BODYMAP/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/BODYMAP/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_BODYMAP = "app/BODYMAP/ADD_BODYMAP";
export const ADD_BODYMAP_SUCCESS = "app/BODYMAP/ADD_BODYMAP_SUCCESS";
export const ADD_BODYMAP_FAILURE = "app/BODYMAP/ADD_BODYMAP_FAILURE";

// EDIT
export const EDIT_BODYMAP = "app/BODYMAP/EDIT_BODYMAP";
export const EDIT_BODYMAP_SUCCESS = "app/BODYMAP/EDIT_BODYMAP_SUCCESS";
export const EDIT_BODYMAP_FAILURE = "app/BODYMAP/EDIT_BODYMAP_FAILURE";

// DELETE
export const DELETE_BODYMAP = "app/BODYMAP/DELETE_BODYMAP";
export const DELETE_BODYMAP_SUCCESS = "app/BODYMAP/DELETE_BODYMAP_SUCCESS";
export const DELETE_BODYMAP_FAILURE = "app/BODYMAP/DELETE_BODYMAP_FAILURE";
